import { createFileRoute } from "@tanstack/react-router";
import AdminSecurityLatest from "@/pages/AdminSecurityLatest";

export const Route = createFileRoute("/admin/security/latest/")({
  component: AdminSecurityLatest,
});
